import React, { useMemo, useState } from "react";
import PayPal from "../payment/PayPal";
import { FormControlLabel, Radio, RadioGroup } from "@mui/material";
import Clover from "../payment/Clover";
import { useAppDispatch, useAppSelector } from "hooks/store";
import { placeOrder } from "store/slices/main.slice";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import { ORDER } from "utils/constants";

type Props = {
  // amount?: number;
  setShowPopup: (v: string) => void;
  setOrderTotal: (v: number) => void;
  setStage: (v: string) => void;
};

const PaymentView = ({ setStage, setShowPopup, setOrderTotal }: Props) => {
  const checkoutData = useAppSelector(({ main }) => main.checkoutData);
  const companyData = useAppSelector(({ main }) => main.companyData);
  const settings = useAppSelector(({ main }) => main.settings);
  const [paymentType, setpaymentType] = useState("");
  const dispatch = useAppDispatch();

  const { allowPayPal, allowClover } = useMemo(() => {
    let allowPayPal = false;
    let allowClover = false;

    if (checkoutData?.orderType === "TakeOut") {
      allowPayPal = settings.PaypalPickup === 1;
      allowClover = settings.CloverPickup === 1;
    } else {
      allowPayPal = settings.PaypalDelivery === 1;
      allowClover = settings.CloverDelivery === 1;
    }

    if (allowPayPal && !allowClover) {
      setpaymentType("pay_pal");
    }
    if (allowClover && !allowPayPal) {
      setpaymentType("clover");
    }
    return { allowPayPal, allowClover };
  }, [checkoutData, settings]);

  const deliveryCharge = useMemo(() => {
    const orderType = checkoutData?.orderType;
    if (orderType !== ORDER.DELIVERY) return 0;

    return companyData?.deliveryCharge || 0;
  }, [checkoutData?.orderType, companyData?.deliveryCharge]);

  if (!checkoutData) return <></>;

  return (
    <div className="w-full ">
      <div className="flex justify-between items-center px-4 pb-2 border-b">
        <div onClick={() => setStage("CHECKOUT")}>
          <ArrowBackIosNewIcon className="!text-[15px] !text-primary cursor-pointer" />
        </div>
        <h4 className="!text-lg text-primary font-semibold text-center">
          Make Payment
        </h4>
        <div />
      </div>
      {allowPayPal && allowClover && (
        <RadioGroup
          value={paymentType}
          onChange={(e) => setpaymentType(e.target.value)}
          row
          className="flex justify-center mt-2 border-b"
          name="row-radio-buttons-group"
        >
          <FormControlLabel
            value="pay_pal"
            control={<Radio size="small" />}
            label="Pay Pal"
          />
          <FormControlLabel
            value="clover"
            control={<Radio size="small" />}
            label="Clover"
          />
        </RadioGroup>
      )}
      {!paymentType && (
        <div className="text-center mt-4">
          {allowPayPal || allowClover
            ? "Please select a payment method"
            : "No payment mode active, please try again later"}
        </div>
      )}
      {paymentType === "pay_pal" && (
        <PayPal
          value={checkoutData.total.toFixed(2)}
          onSubmit={() =>
            dispatch(
              placeOrder({
                paymentType: "oncounter",
                setStage,
                setShowPopup,
                action: "pay_pal",
                setOrderTotal,
                deliveryCharge,
              })
            )
          }
        />
      )}
      {paymentType === "clover" && (
        <Clover
          value={checkoutData.total}
          onSubmit={() =>
            dispatch(
              placeOrder({
                paymentType: "oncounter",
                setStage,
                action: "clover",
                setShowPopup,
                setOrderTotal,
                deliveryCharge,
              })
            )
          }
        />
      )}
    </div>
  );
};

export default PaymentView;
